import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  RECEIVE_SUBSCRIPTIONS,
  RECEIVE_USER_EMAIL_ADDRESSES,
} from "@/components/privacy/ducks/Actions"

const defaultState = {
  userEmailAddresses: [],
  subscriptions: {},
}

const userPrivacyReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_USER_EMAIL_ADDRESSES:
      return {
        ...oldState,
        userEmailAddresses: action.userEmailAddresses,
      }
    case RECEIVE_SUBSCRIPTIONS:
      return {
        ...oldState,
        subscriptions: action.subscriptions,
      }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default userPrivacyReducer
